import axios from 'axios';
import responseMapperInterceptor from './responseMapperInterceptor';
import { refreshTokenInterceptor } from './refreshTokenInterceptor';
import { backendUnavailableInterceptor } from './backendUnavailableInterceptor';
import authInterceptor from '../authInterceptor';
import errorHandlerInterceptor from 'services/errorHandlerInterceptor';

const axiosInstance = function () {
  const axiosInstance = axios.create();

  axiosInstance.interceptors.response.use(
    (response) => response,
    refreshTokenInterceptor(axiosInstance),
  );
  axiosInstance.interceptors.response.use(
    (response) => response,
    backendUnavailableInterceptor(axiosInstance),
  );

  axiosInstance.interceptors.response.use(
    (response) => response,
    errorHandlerInterceptor(axiosInstance),
  );

  axiosInstance.interceptors.response.use(...responseMapperInterceptor);

  axiosInstance.interceptors.request.use(authInterceptor);

  return axiosInstance;
};
export default axiosInstance();
